var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.QRImgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }